{
  "version": 1,
  "asset_id": "a2053c2d-0208-44a7-bf41-10033d812aaa",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/a2053c2d-0208-44a7-bf41-10033d812aaa/campsite-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/a2053c2d-0208-44a7-bf41-10033d812aaa/campsite-card.webp",
  "original_filename": "campsite-card.webp",
  "size": 16998,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:25:28Z"
}
